<template>
  <CModal
    title="Add vendor"
    size="lg"
    :show="show"
    @update:show="$emit('close')"
  >
    <CRow>
      <CCol md="6">
        <CInput
          ref="nameInput"
          label="Company name *"
          v-model="localVendor.name"
          placeholder="e.g. Vendor Sdn Bhd"
          :is-valid="fieldValid('name')"
          invalid-feedback="Enter the vendor's name"
        />
        <CInput
          label="Contact name"
          v-model="localVendor.contactName"
          placeholder="Contact person's name"
        />
        <CInput
          label="Contact email"
          v-model="localVendor.contactEmail"
          placeholder="contact@example.com"
          type="email"
        />
        <CInput
          label="Contact phone"
          v-model="localVendor.contactPhone"
          placeholder="012-345 6789"
          type="tel"
        />
      </CCol>
      <CCol md="6">
        <CTextarea
          ref="addressInput"
          label="Address *"
          placeholder="e.g. No. 123, Jalan Example, Taman Example"
          rows="4"
          v-model="localVendor.address"
          :is-valid="fieldValid('address')"
          invalid-feedback="Enter the vendor's address. It's printed on purchase orders"
        />
        <CRow>
          <CCol sm="6">
            <CInput label="City" v-model="localVendor.city" />
          </CCol>
          <CCol sm="6">
            <CInput label="Postcode" inputmode="numeric" v-model="localVendor.postcode" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput label="State" v-model="localVendor.state" />
          </CCol>
          <CCol sm="6">
            <CInput label="Country" v-model="localVendor.country" />
          </CCol>
        </CRow>
        <CInput label="Phone" type="tel" v-model="localVendor.phone" placeholder="03-1234 5678" />
        <CInput label="Website" v-model="localVendor.website" placeholder="www.example.com" />
      </CCol>
    </CRow>
    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <CButton color="light" @click="$emit('close')">Cancel</CButton>
        <CButton color="primary" @click="saveVendor">Add vendor</CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "VendorFormModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    vendor: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localVendor: { ...this.vendor },
      submitted: false,
    };
  },
  watch: {
    vendor: {
      handler(newVendor) {
        this.localVendor = { ...newVendor };
      },
      deep: true,
    },
    show(newValue) {
      if (newValue) {
        this.localVendor = { ...this.vendor };
        this.submitted = false;
      }
    },
  },
  computed: {
    isValid() {
      return this.hasValue("name") && this.hasValue("address");
    },
  },
  methods: {
    hasValue(field) {
      const v = this.localVendor[field];
      return !!(v && String(v).trim());
    },
    fieldValid(field) {
      if (!this.submitted) return null;
      return this.hasValue(field) || false;
    },
    saveVendor() {
      this.submitted = true;
      if (this.isValid) {
        this.$emit("save", this.localVendor);
        return;
      }
      const ref = !this.hasValue("name") ? this.$refs.nameInput : this.$refs.addressInput;
      this.$nextTick(() => {
        const el = ref && ref.$el.querySelector("input, textarea");
        if (el) el.focus();
      });
    },
  },
};
</script>
